import BaseLayout from "@layout/base-layout";
import NewSearchSystem from "@components/search/NewSearchSystem";

const IndexSearch = () => {
  return (
    <BaseLayout page="search">
      <NewSearchSystem />
    </BaseLayout>
  );
};

export default IndexSearch;
